module.exports = __webpack_public_path__ + "static/image-target-icon-d905cc0236fc9d67be014bf9bf87f77f.svg";